/* eslint-disable newline-after-var */
// app ids taken from https://developers.facebook.com
const FACEBOOK_APP_CONFIG = {
  PROD: {
    appId: 647456452727479, // MCA SI app
    sdkUrl: 'https://connect.facebook.net/en_US/sdk.js',
    sdkVersion: 'v8.0',
    env: 'PROD',
  },
  SI: {
    appId: 768575197290072,
    sdkUrl: 'https://connect.facebook.net/en_US/sdk.js',
    sdkVersion: 'v8.0',
    env: 'SI',
  },
  LOCAL: {
    appId: 768575197290072,
    sdkUrl: 'https://connect.facebook.net/en_US/sdk/debug.js',
    sdkVersion: 'v8.0',
    env: 'LOCAL',
  },
};

/**
 * Determines what environment the site is running in, based on the domain.
 * @param {string} domain - Current domain.
 * @returns {string} - Environment the site is running in.
 */
export function getEnvironment(domain) {
  const prodBingAdsPattern = /^(ui\.)?bingads\.microsoft\.com$/;
  const prodMicrosoftAdsPattern = /^(ui\.)?ads\.microsoft\.com$/;
  if (domain.match(prodMicrosoftAdsPattern) || domain.match(prodBingAdsPattern)) {
    return 'PROD';
  }

  const betaprodBingAdsPattern = /^(ui\.)?beta\.bingads\.microsoft\.com$/;
  const betaprodMicrosoftAdsPattern = /^(ui\.)?beta\.ads\.microsoft\.com$/;
  if (domain.match(betaprodMicrosoftAdsPattern) || domain.match(betaprodBingAdsPattern)) {
    return 'BETAPROD';
  }

  const tipBingAdsPattern = /^(ui\.)?tip\.bingads\.microsoft\.com$/;
  const tipMicrosoftAdsPattern = /^(ui\.)?tip\.?ads\.microsoft\.com$/;
  if (domain.match(tipBingAdsPattern) || domain.match(tipMicrosoftAdsPattern)) {
    return 'TIP';
  }

  const siBingAdsPattern = /^(ui\.)?si\.bingads\.microsoft\.com$/;
  const siMicrosoftAdsPattern = /^(ui\.)?ads-int\.microsoft\.com$/;
  if (domain.match(siMicrosoftAdsPattern) || domain.match(siBingAdsPattern)) {
    return 'SI';
  }

  const betasiBingAdsPattern = /^(ui\.)?beta\.si\.bingads\.microsoft\.com$/;
  const betasiMicrosoftAdsPattern = /^(ui\.)?beta\.ads-int\.microsoft\.com$/;
  if (domain.match(betasiMicrosoftAdsPattern) || domain.match(betasiBingAdsPattern)) {
    return 'BETASI';
  }

  return 'LOCAL';
}

export function getFacebookConfig(domain) {
  const environment = getEnvironment(domain);
  switch (environment) {
    case 'PROD':
    case 'BETAPROD':
    case 'TIP':
      return FACEBOOK_APP_CONFIG.PROD;
    case 'SI':
    case 'BETASI':
      return FACEBOOK_APP_CONFIG.SI;
    default:
      return FACEBOOK_APP_CONFIG.LOCAL;
  }
}
